import React from 'react';
import ReactDOM from 'react-dom';

export const DOWNLOAD_ERROR_MESSAGE =
    'This file cannot be downloaded right now. Please contact the administrator.';

export default function DownloadErrorModal({ open, message = DOWNLOAD_ERROR_MESSAGE, onClose }) {
    if (!open) return null;

    const modalRoot = typeof document !== 'undefined' ? document.getElementById('modal') : null;
    if (!modalRoot) return null;

    const handleClose = () => {
        if (onClose) onClose();
    };

    return ReactDOM.createPortal(
        <div className="download-modal__overlay" onClick={handleClose} role="presentation">
            <div
                className="download-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="download-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="download-modal__header">
                    <div className="download-modal__icon" aria-hidden="true">
                        !
                    </div>
                    <h4 className="download-modal__title" id="download-modal-title">
                        Download unavailable
                    </h4>
                </div>
                <p className="download-modal__text">{message}</p>
                <div className="download-modal__actions">
                    <button type="button" className="download-modal__button" onClick={handleClose}>
                        OK
                    </button>
                </div>
            </div>
        </div>,
        modalRoot
    );
}
